import * as $ from 'jquery'

export default function seedCompanyFilterInit() {
  const $filterContainer = $('[data-sc-filters]')
  if (!$filterContainer.length) return

  const $cardDeck = $('[data-sc-card-deck]')
  const $cards = $cardDeck.find('.sc-story-card-wrapper')

  const activeFilters: Record<string, string> = {}

  $filterContainer.find('[data-filter-group]').each(function () {
    const group = $(this).data('filter-group') as string
    activeFilters[group] = 'all'
  })

  function matchesFilter(cardValue: string, filterValue: string): boolean {
    const v = String(filterValue)
    if (v === 'all') return true
    if (!cardValue) return false

    const values = String(cardValue).split(',').map((s) => s.trim().toLowerCase())
    return values.includes(v.toLowerCase())
  }

  function applyFilters() {
    $cards.each(function () {
      const $card = $(this)
      let visible = true

      for (const [group, filterValue] of Object.entries(activeFilters)) {
        const cardData = ($card.attr(`data-filter-${group}`) || '') as string
        if (!matchesFilter(cardData, filterValue)) {
          visible = false
          break
        }
      }

      if (visible) {
        $card.show()
      } else {
        $card.hide()
      }
    })
  }

  $filterContainer.on('click', '.sc-filters__btn', function () {
    const $btn = $(this)
    const $group = $btn.closest('[data-filter-group]')
    const filterGroup = $group.data('filter-group') as string
    const filterValue = $btn.data('filter-value') as string

    $group.find('.sc-filters__btn').removeClass('sc-filters__btn--active')
    $btn.addClass('sc-filters__btn--active')

    activeFilters[filterGroup] = filterValue

    applyFilters()
  })
}

// Keep in sync with the $milestone-icons map in
// app/frontend/stylesheets/themes/seed_company/_milestone-icons.scss.
const MILESTONE_ICON_CLASSES = [
  'first-scriptures',
  'new-testament',
  'full-bible',
  'sign-language',
  'additional-scripture',
]

export function seedMilestoneTooltipsInit() {
  const $keyLists = $('.section-block-text ul').filter(function () {
    return MILESTONE_ICON_CLASSES.some((cls) => $(this).find(`> li.${cls}`).length > 0)
  })
  if (!$keyLists.length) return

  const labels: Record<string, string> = {}
  $keyLists.first().find('> li').each(function () {
    const $li = $(this)
    const cls = MILESTONE_ICON_CLASSES.find((c) => $li.hasClass(c))
    if (cls) labels[cls] = $li.text().trim()
  })

  $(MILESTONE_ICON_CLASSES.map((c) => `li.${c}`).join(', ')).each(function () {
    const $li = $(this)
    if ($li.closest('.section-block-text').length) return
    const cls = MILESTONE_ICON_CLASSES.find((c) => $li.hasClass(c))
    if (cls && labels[cls]) $li.attr('data-tooltip', labels[cls])
  })
}

// CSS typed attr() isn't supported by Firefox, so we set `--pct` from
// `data-value` / `data-max` imperatively here.
export function seedMilestoneProgressInit() {
  $('.total').each(function () {
    const el = this as HTMLElement
    const value = Number(el.getAttribute('data-value') || '0')
    const max = Number(el.getAttribute('data-max') || '0')
    const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0
    el.style.setProperty('--pct', String(pct))
    if (value === 0) el.setAttribute('data-progress-state', 'not-started')
  })

  $('.section-card-deck .card li, .seed-region-card li').each(function () {
    const $li = this as HTMLElement
    const cls = MILESTONE_ICON_CLASSES.find((c) => $li.classList.contains(c))
    if (!cls) return
    const text = ($li.textContent || '').trim()
    if (text === '0') $li.setAttribute('hidden', 'hidden')
  })
}

export function seedMilestoneFilterInit() {
  const $filterContainers = $('[data-sc-milestone-filters]')
  if (!$filterContainers.length) return

  function matchesFilter(cardValue: string, filterValue: string): boolean {
    const v = String(filterValue)
    if (v === 'all') return true
    if (!cardValue) return false
    const values = String(cardValue).split(',').map((s) => s.trim().toLowerCase())
    return values.includes(v.toLowerCase())
  }

  $filterContainers.each(function () {
    const $container = $(this)
    const targetName = ($container.data('target') as string) || ''
    const $grid = targetName
      ? $(`[data-sc-milestones][data-target-name="${targetName}"]`)
      : $('[data-sc-milestones]').first()
    if (!$grid.length) return

    const $cards = $grid.find('.sc-milestone-card')
    const $emptyState = targetName
      ? $(`[data-sc-milestones-empty][data-target-name="${targetName}"]`)
      : $('[data-sc-milestones-empty]').first()
    const activeFilters: Record<string, string> = {}

    function humanize(raw: string): string {
      return raw
        .split(/[-_\s]+/)
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ')
    }

    function sortValues(values: string[]): string[] {
      return values.slice().sort((a, b) => {
        const an = Number(a)
        const bn = Number(b)
        if (!Number.isNaN(an) && !Number.isNaN(bn)) return bn - an
        return a.localeCompare(b)
      })
    }

    $container.find('[data-filter-group]').each(function () {
      const $group = $(this)
      const group = $group.data('filter-group') as string
      activeFilters[group] = 'all'

      const seen = new Set<string>()
      $cards.each(function () {
        const raw = String($(this).attr(`data-filter-${group}`) || '')
        raw.split(',').forEach((v) => {
          const trimmed = v.trim()
          if (trimmed) seen.add(trimmed)
        })
      })

      const $menu = $group.find('.sc-milestone-filters__menu')
      sortValues(Array.from(seen)).forEach((value) => {
        const label = humanize(value)
        $('<button>', {
          type: 'button',
          class: 'sc-milestone-filters__option',
          role: 'menuitem',
          'data-filter-value': value,
          'data-pill-label': label,
          text: label,
        }).appendTo($menu)
      })
    })

    function applyFilters() {
      let visibleCount = 0
      $cards.each(function () {
        const $card = $(this)
        let visible = true
        for (const [group, filterValue] of Object.entries(activeFilters)) {
          const cardData = ($card.attr(`data-filter-${group}`) || '') as string
          if (!matchesFilter(cardData, filterValue)) {
            visible = false
            break
          }
        }
        if (visible) {
          $card.show()
          visibleCount += 1
        } else {
          $card.hide()
        }
      })

      if ($emptyState.length) {
        if (visibleCount === 0) {
          $emptyState.removeAttr('hidden')
          $grid.attr('hidden', 'hidden')
        } else {
          $emptyState.attr('hidden', 'hidden')
          $grid.removeAttr('hidden')
        }
      }
    }

    if ($emptyState.length) {
      $emptyState.on('click', '[data-sc-milestones-reset]', function () {
        $container.find('[data-filter-group]').each(function () {
          const $group = $(this)
          const group = $group.data('filter-group') as string
          const $allOption = $group.find('.sc-milestone-filters__option[data-filter-value="all"]')
          const defaultLabel = ($allOption.data('pill-label') as string) || $allOption.text().trim()

          $group.find('.sc-milestone-filters__option').removeClass('sc-milestone-filters__option--active')
          $allOption.addClass('sc-milestone-filters__option--active')
          $group.find('[data-pill-text]').text(defaultLabel)

          const detailsEl = $group.get(0) as HTMLDetailsElement | undefined
          if (detailsEl) detailsEl.open = false

          activeFilters[group] = 'all'
        })

        applyFilters()
      })
    }

    $container.find('details[data-filter-group]').each(function () {
      const details = this as HTMLDetailsElement
      details.addEventListener('toggle', () => {
        if (!details.open) return
        $container.find('details[data-filter-group]').each(function () {
          if (this !== details) (this as HTMLDetailsElement).open = false
        })
      })
    })

    $container.on('click', '.sc-milestone-filters__option', function (e) {
      e.preventDefault()
      const $option = $(this)
      const $group = $option.closest('[data-filter-group]')
      const filterGroup = $group.data('filter-group') as string
      const filterValue = $option.data('filter-value') as string
      const pillLabel = ($option.data('pill-label') as string) || $option.text().trim()

      $group.find('.sc-milestone-filters__option').removeClass('sc-milestone-filters__option--active')
      $option.addClass('sc-milestone-filters__option--active')
      $group.find('[data-pill-text]').text(pillLabel)

      const detailsEl = $group.get(0) as HTMLDetailsElement | undefined
      if (detailsEl) detailsEl.open = false

      activeFilters[filterGroup] = filterValue
      applyFilters()
    })
  })

  $(document).on('click', function (e) {
    const $clicked = $(e.target as Element)
    if ($clicked.closest('[data-sc-milestone-filters]').length) return
    $filterContainers.find('details[open]').each(function () {
      (this as HTMLDetailsElement).open = false
    })
  })
}
